import axios from "axios";
import { getButtonList } from "../../promissionRouter";
import { getSearchDataIndex } from "util/util";

export const TwTable_mixins = {
    data() {
        return {
            // 每个页面的表格
            tableData: [],      // 表格数据
            pageConfig: {       // 分页配置
                total: 0,
                pageIndex: 1,
                pageSize: 50,
                pageSizes: [20, 50, 100,500]
            },

            // 当前行 
            currentRow: null,
            // 查询的参数
            searchParams: {},
            // 选中的行
            selectRows: { rows: [], row: {} },

            // 搜索的数据
            filters: {},
            // 待覆盖的搜索数据
            newfilters: {},

            // 
            formData: {
                roleIds: []
            },

            // 日志
            showLog: false,         // 日志弹窗的显示隐藏
            logPageConfig: {        // 日志分页配置
                total: 0,
                pageIndex: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100]
            },
            roleIdsOptions: [],

            showEditDialog: false,
            currentTab: '', // 保存tab栏点击的参数
            buttonList: [],  // 按钮
        }
    },

    created() {

    },

    mounted() {

    },

    computed: {

    },

    methods: {
        // 当前行的点击事件
        selectCurrentRow(val) {
            this.currentRow = val;
        },
        // 操作的事件分发
        handleOperateEvent(event, val) {
            this[event](val);
        },
        // 单元格点击事件
        handleCellClick(row, column, cell, event) {
            this.currentRow = row
        },
        // 多选框的选择事件
        handleSelectCheckbox(sel, row) {
            this.selectRows = {
                rows: sel,
                row
            }

        },
        //多选框改变事件
        handleSelsChange(sel) {
            this.selectRows = {
                rows: sel,
            }
        },
        // 是否选中了一条数据
        isSelectRow(rows) {
            const that = this
            return new Promise(function (resolve, reject) {
                var row = rows ? rows : that.currentRow;
                if (!row) {
                    that.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error"
                    });
                    reject()
                }
                resolve(row)
            })
        },
        // 搜索内容改变事件
        searchChange(data) {
            this.filters = Object.assign({}, this.filters, data)
        },
        // pageSize改变事件
        handleSizeChange(pageSize) {
            this.$set(this.pageConfig, 'pageSize', pageSize);
            // 统一的初始化table函数
            this.initTable();
        },
        // pageIndex页码改变事件
        handleCurrentChange(val) {
            this.$set(this.pageConfig, 'pageIndex', val)
            this.initTable();
        },
        // 日志关闭事件
        showDialog() {
            this.showLog = !this.showLog
            this.$set(this.logPageConfig, 'pageIndex', 1)
        },
        // 日志pageSize改变事件
        // handleLogSizeChange(val) {
        //     this.$set(this.logPageConfig,'pageSize',val)
        //     // this.getbusinessLoglist();
        // },
        // // 日志当前页改变事件
        // handleLogCurrentChange(val) {
        //     this.$set(this.logPageConfig,'pageIndex',val)
        //     // this.getbusinessLoglist();
        // },

        // operate事件
        showOperateDialog() {
            // this.showEditDialog = !this.showEditDialog
        },

        operateCancel(control) {
            this[control] = !this[control]
        },

        // 接收组件抛出的table组件
        getTableEle(ele) {
            this.tableEle = ele
        },

        // tab栏点击事件
        handleTabsClick(val) {
            this.currentTab = val
            this.initTable();
        },
        // 导出文件
        exportFile(url, params) {
            const loading = this.$loading({
                lock: true,
                text: "导出中，请稍等",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.5)",
            });
            axios({
                url: url,
                method: "post",
                data: params,
                //responseType: "blob",
            })
                .then((res) => {
                    loading.close();
                    if (res.data.success) {
                        var data = res.data.response;

                        var arr = data.fileData.split(",");
                        var mime = arr[0].match(/:(.*?);/)[1];
                        var bstr = atob(arr[1]);
                        var n = bstr.length;
                        var u8arr = new Uint8Array(n);
                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n);
                        }
                        var blob = new Blob([u8arr], { type: mime });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        let fileName = data.fileName;
                        a.download = decodeURIComponent(fileName);
                        a.click();
                        window.URL.revokeObjectURL(url);
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "error",
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        /**
         * @description 获取表格数据
         * @param {request} 请求promise
         * @param {params} 请求参数
         * @returns {response} 返回数据
         */
        getTableData(request, params) {
            let _this = this
            this.tableConfig.loading = true;
            this.searchParams = params;
            this.tableConfig.showPage = false;
            return new Promise((resolve, reject) => {
                request(params).then(res => {
                    if (res.success || res.status === 200) {
                        if (res.response) {
                            const { total, pageData, pageIndex, pageSize } = res.response;
                            _this.$set(_this.pageConfig, "total", total);
                            _this.$set(_this.pageConfig, "pageIndex", pageIndex);
                            _this.$set(_this.pageConfig, "pageSize", pageSize);
                            _this.tableData = pageData;
                            _this.tableConfig.loading = false;
                            _this.tableConfig.showPage = true;
                            resolve(res)
                        } else if (res.data.response) {
                            // 前端分页
                            let data = res.data.response
                            _this.$set(_this.pageConfig, "total", data.length);
                            _this.$set(_this.pageConfig, "pageIndex", params.page);
                            _this.$set(_this.pageConfig, "pageSize", params.pageSize);
                            _this.tableData = data.slice((params.page - 1) * params.pageSize, params.page * params.pageSize);
                            _this.tableConfig.loading = false;
                            _this.tableConfig.showPage = true;
                            resolve(res)
                        }

                    } else {
                        _this.$set(_this.pageConfig, "total", 0);
                        _this.$set(_this.pageConfig, "pageIndex", 1);
                        _this.$set(_this.pageConfig, "pageSize", 0);
                        _this.tableData = [];
                        _this.tableConfig.loading = false;
                        _this.tableConfig.showPage = true;
                    }
                })
            }).catch(() => console.log('请求接口出错'));
        },
        // 获取按钮
        getMixinsButtonList() {
            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];

            this.buttonList = getButtonList(this.$route.path, routers);
        },
        /**
         * @description 设置搜索栏下拉框options
         * @param {optionsParent} 搜索条件所在父级key
         * @param {key} 搜索条件key
         * @param {options} 下拉数据
         */
        setSearchOptions(optionsParent, key, options) {
            this.$set(
                this.searchData[optionsParent][
                getSearchDataIndex(this.searchData[optionsParent], key)
                ],
                "options",
                options
            );
        },
        /**
         * @description 校验选择数据
         * @param {status} 数据状态,可多个
         * @param {statusKey} 状态字段
         * @param {errorTip} 失败提示
         * @param {multiple} 允许多选
         * @return {then} 校验通过
         * 
         */
        validSelectRows(status, statusKey, errorTip, multiple = false) {
            return new Promise((resolve, reject) => {
                let rowData = this.selectRows.rows
                if (multiple && rowData && rowData.length) {
                    let rowStatus = rowData.map(item => item[statusKey])
                    let applyArr = []
                    rowStatus.forEach(element => {
                        if (!(status.includes(element))) {
                            applyArr.push(element)
                        }
                    });
                    if (!(applyArr.length)) {
                        resolve(rowData)
                    } else {
                        this.$message({
                            message: errorTip,
                            type: "error",
                        });
                    }
                } else if (rowData && rowData.length === 1) {

                    if (status.includes(rowData[0][statusKey])) {
                        resolve(rowData[0])
                    } else {
                        this.$message({
                            message: errorTip,
                            type: "error",
                        });
                    }
                } else {
                    this.$message({
                        message: "请选择一条数据！",
                        type: "error",
                    });
                }

            })
        }
    }
}